<template>
  <vs-row class="flex w-auto mr-4" vs-align="center" :class="size==='mobile' ? 'layout-mobile' : ''">
    <vs-col class="w-auto mr-4">{{ label }}</vs-col>
    <vs-col class="w-auto">
      <vs-input :class="size" icon-pack="feather" icon="icon-search" placeholder="Search"
                v-model="keyword" @change="changeText" @keyup="keyupEvent"/>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'SearchNavItemKeyword',
  props: {
    label: String,
    value: String,
    size: {
      type: String,
      default: 'normal'
    }
  },
  watch: {
    value (value) {
      this.keyword = value
    }
  },
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    changeText () {
      this.$emit('input', this.keyword)
    },

    keyupEvent (event) {
      if (event.code === 'NumpadEnter' || event.code === 'Enter') {
        this.$emit('keyupEvent', event.target.value)
      }
    }
  }
}
</script>

<style scoped>

.layout-mobile {
  display: grid !important;
  grid-template-columns: 70px 1fr;
  margin:0 0 1rem 0 !important;
}
.mobile {
  width:100%;
}
.small {
  width: 100px;
}

.normal {
  width: 130px;
}

.large {
  width: 160px;
}
</style>
